import { Service } from '@angular/core';
import { localStorageSignal } from '@ddtmm/angular-signal-generators';
import { EmployeeCoreDto } from '@app/_api/dto';

export type TreeView = 'list' | 'canvas';

@Service()
export class TreeViewDataService {
  readonly $employeeView = localStorageSignal<EmployeeCoreDto | undefined>(undefined, 'employeeView');
  readonly $treeView = localStorageSignal<TreeView>('canvas', 'treeView');
}
